export const resource = [
  {
    title: '常见物流问题',
  },
  {
    title: '订单问题',
  },
  {
    title: '支付问题',
  },
  {
    title: '取消订单',
  },
  {
    title: '发票问题',
  },
  {
    title: '退款流程',
  },
];
